import W from "./index73.js";
import n from "./index49.js";
import o from "./index60.js";
import we from "./index89.js";
import { trackStream as re } from "./index90.js";
import ne from "./index63.js";
import { progressEventDecorator as se, progressEventReducer as oe, asyncDecorator as ae } from "./index87.js";
import Re from "./index88.js";
import ye from "./index85.js";
import be from "./index91.js";
import { VERSION as Se } from "./index58.js";
import { toByteStringHeaderObject as Ee } from "./index75.js";
const ie = 64 * 1024, { isFunction: v } = n, xe = (a) => encodeURIComponent(a).replace(
  /%([0-9A-F]{2})/gi,
  (l, f) => String.fromCharCode(parseInt(f, 16))
), ue = (a) => {
  if (!n.isString(a))
    return a;
  try {
    return decodeURIComponent(a);
  } catch {
    return a;
  }
}, ce = (a, ...l) => {
  try {
    return !!a(...l);
  } catch {
    return !1;
  }
}, Le = (a) => {
  const l = a.indexOf("://");
  let f = a;
  return l !== -1 && (f = f.slice(l + 3)), f.includes("@") || f.includes(":");
}, Ce = (a) => {
  const l = n.global !== void 0 && n.global !== null ? n.global : globalThis, { ReadableStream: f, TextEncoder: P } = l;
  a = n.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: l.Request,
      Response: l.Response
    },
    a
  );
  const { fetch: q, Request: m, Response: B } = a, y = q ? v(q) : typeof fetch == "function", h = v(m), L = v(B);
  if (!y)
    return !1;
  const C = y && v(f), le = y && (typeof P == "function" ? ((e) => (s) => e.encode(s))(new P()) : async (e) => new Uint8Array(await new m(e).arrayBuffer())), V = h && C && ce(() => {
    let e = !1;
    const s = new m(W.origin, {
      body: new f(),
      method: "POST",
      get duplex() {
        return e = !0, "half";
      }
    }), u = s.headers.has("Content-Type");
    return s.body != null && s.body.cancel(), e && !u;
  }), N = L && C && ce(() => n.isReadableStream(new B("").body)), F = {
    stream: N && ((e) => e.body)
  };
  y && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !F[e] && (F[e] = (s, u) => {
      let c = s && s[e];
      if (c)
        return c.call(s);
      throw new o(
        `Response type '${e}' is not supported`,
        o.ERR_NOT_SUPPORT,
        u
      );
    });
  });
  const Q = async (e) => {
    if (e == null)
      return 0;
    if (n.isBlob(e))
      return e.size;
    if (n.isSpecCompliantForm(e))
      return (await new m(W.origin, {
        method: "POST",
        body: e
      }).arrayBuffer()).byteLength;
    if (n.isArrayBufferView(e) || n.isArrayBuffer(e))
      return e.byteLength;
    if (n.isURLSearchParams(e) && (e = e + ""), n.isString(e))
      return (await le(e)).byteLength;
  }, de = async (e, s) => {
    const u = n.toFiniteNumber(e.getContentLength());
    return u ?? Q(s);
  };
  return async (e) => {
    let {
      url: s,
      method: u,
      data: c,
      signal: fe,
      cancelToken: Z,
      timeout: pe,
      onDownloadProgress: H,
      onUploadProgress: j,
      responseType: b,
      headers: S,
      withCredentials: z = "same-origin",
      fetchOptions: $,
      maxContentLength: g,
      maxBodyLength: k
    } = Re(e);
    const U = n.isNumber(g) && g > -1, M = n.isNumber(k) && k > -1, me = (r) => n.hasOwnProp(e, r) ? e[r] : void 0;
    let G = q || fetch;
    b = b ? (b + "").toLowerCase() : "text";
    let E = we(
      [fe, Z && Z.toAbortSignal()],
      pe
    ), i = null;
    const _ = E && E.unsubscribe && (() => {
      E.unsubscribe();
    });
    let O, A = null;
    const J = () => new o(
      "Request body larger than maxBodyLength limit",
      o.ERR_BAD_REQUEST,
      e,
      i
    );
    try {
      let r;
      const p = me("auth");
      if (p) {
        const t = n.getSafeProp(p, "username") || "", d = n.getSafeProp(p, "password") || "";
        r = {
          username: t,
          password: d
        };
      }
      if (Le(s)) {
        const t = new URL(s, W.origin);
        if (!r && (t.username || t.password)) {
          const d = ue(t.username), x = ue(t.password);
          r = {
            username: d,
            password: x
          };
        }
        (t.username || t.password) && (t.username = "", t.password = "", s = t.href);
      }
      if (r && (S.delete("authorization"), S.set(
        "Authorization",
        "Basic " + btoa(xe((r.username || "") + ":" + (r.password || "")))
      )), U && typeof s == "string" && s.startsWith("data:") && be(s) > g)
        throw new o(
          "maxContentLength size of " + g + " exceeded",
          o.ERR_BAD_RESPONSE,
          e,
          i
        );
      if (M && u !== "get" && u !== "head") {
        const t = await Q(c);
        if (typeof t == "number" && isFinite(t) && (O = t, t > k))
          throw J();
      }
      const I = M && (n.isReadableStream(c) || n.isStream(c)), X = (t, d, x) => re(
        t,
        ie,
        (T) => {
          if (M && T > k)
            throw A = J();
          d && d(T);
        },
        x
      );
      if (V && u !== "get" && u !== "head" && (j || I)) {
        if (O = O ?? await de(S, c), O !== 0 || I) {
          let t = new m(s, {
            method: "POST",
            body: c,
            duplex: "half"
          }), d;
          if (n.isFormData(c) && (d = t.headers.get("content-type")) && S.setContentType(d), t.body) {
            const [x, T] = j && se(
              O,
              oe(ae(j))
            ) || [];
            c = X(t.body, x, T);
          }
        }
      } else if (I && !h && C && u !== "get" && u !== "head")
        c = X(c);
      else if (I && h && !V && u !== "get" && u !== "head")
        throw new o(
          "Stream request bodies are not supported by the current fetch implementation",
          o.ERR_NOT_SUPPORT,
          e,
          i
        );
      n.isString(z) || (z = z ? "include" : "omit");
      const he = h && "credentials" in m.prototype;
      if (n.isFormData(c)) {
        const t = S.getContentType();
        t && /^multipart\/form-data/i.test(t) && !/boundary=/i.test(t) && S.delete("content-type");
      }
      S.set("User-Agent", "axios/" + Se, !1);
      const Y = {
        ...$,
        signal: E,
        method: u.toUpperCase(),
        headers: Ee(S.normalize()),
        body: c,
        duplex: "half",
        credentials: he ? z : void 0
      };
      i = h && new m(s, Y);
      let w = await (h ? G(i, $) : G(s, Y));
      const ee = ne.from(w.headers);
      if (U) {
        const t = n.toFiniteNumber(ee.getContentLength());
        if (t != null && t > g)
          throw new o(
            "maxContentLength size of " + g + " exceeded",
            o.ERR_BAD_RESPONSE,
            e,
            i
          );
      }
      const K = N && (b === "stream" || b === "response");
      if (N && w.body && (H || U || K && _)) {
        const t = {};
        ["status", "statusText", "headers"].forEach((D) => {
          t[D] = w[D];
        });
        const d = n.toFiniteNumber(ee.getContentLength()), [x, T] = H && se(
          d,
          oe(ae(H), !0)
        ) || [];
        let te = 0;
        const ge = (D) => {
          if (U && (te = D, te > g))
            throw new o(
              "maxContentLength size of " + g + " exceeded",
              o.ERR_BAD_RESPONSE,
              e,
              i
            );
          x && x(D);
        };
        w = new B(
          re(w.body, ie, ge, () => {
            T && T(), _ && _();
          }),
          t
        );
      }
      b = b || "text";
      let R = await F[n.findKey(F, b) || "text"](
        w,
        e
      );
      if (U && !N && !K) {
        let t;
        if (R != null && (typeof R.byteLength == "number" ? t = R.byteLength : typeof R.size == "number" ? t = R.size : typeof R == "string" && (t = typeof P == "function" ? new P().encode(R).byteLength : R.length)), typeof t == "number" && t > g)
          throw new o(
            "maxContentLength size of " + g + " exceeded",
            o.ERR_BAD_RESPONSE,
            e,
            i
          );
      }
      return !K && _ && _(), await new Promise((t, d) => {
        ye(t, d, {
          data: R,
          headers: ne.from(w.headers),
          status: w.status,
          statusText: w.statusText,
          config: e,
          request: i
        });
      });
    } catch (r) {
      if (_ && _(), E && E.aborted && E.reason instanceof o) {
        const p = E.reason;
        throw p.config = e, i && (p.request = i), r !== p && Object.defineProperty(p, "cause", {
          __proto__: null,
          value: r,
          writable: !0,
          enumerable: !1,
          configurable: !0
        }), p;
      }
      if (A)
        throw i && !A.request && (A.request = i), A;
      if (r instanceof o)
        throw i && !r.request && (r.request = i), r;
      if (r && r.name === "TypeError" && /Load failed|fetch/i.test(r.message)) {
        const p = new o(
          "Network Error",
          o.ERR_NETWORK,
          e,
          i,
          r && r.response
        );
        throw Object.defineProperty(p, "cause", {
          __proto__: null,
          value: r.cause || r,
          writable: !0,
          enumerable: !1,
          configurable: !0
        }), p;
      }
      throw o.from(r, r && r.code, e, i, r && r.response);
    }
  };
}, _e = /* @__PURE__ */ new Map(), Te = (a) => {
  let l = a && a.env || {};
  const { fetch: f, Request: P, Response: q } = l, m = [P, q, f];
  let B = m.length, y = B, h, L, C = _e;
  for (; y--; )
    h = m[y], L = C.get(h), L === void 0 && C.set(h, L = y ? /* @__PURE__ */ new Map() : Ce(l)), C = L;
  return L;
};
Te();
export {
  Te as getFetch
};
